module.exports = __webpack_public_path__ + "media/images/vibration-62408f7da648d5835d181666f6b69522.svg";